import { useQuery, UseQueryResult } from '@tanstack/react-query'

import { Language } from '@/core/api/entities/misc/language'
import { LanguageMapper } from '@/core/api/mappers/misc/languageMapper'
import languageService from '@/core/api/services/languageService'

export function useLanguages({ config, options }: any = {}): UseQueryResult<
	Language[],
	Error
> {
	const QUERY_KEY = [
		'languages',
		{
			...config?.params,
		},
	]

	return useQuery({
		queryKey: QUERY_KEY,
		queryFn: () =>
			languageService.getLanguages(config).then(({ data }) => {
				return LanguageMapper.toEntities(data.data)
			}),
		...options,
		cacheTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
		staleTime: 86400000, // 24h = 24h * 60m * 60s * 1000ms = 86400000ms
	})
}
